module.exports = __webpack_public_path__ + "fonts/Augillion.457e69a.otf";